const aprovedCountry = "AE"

const aprovedJurisdiction = "Abu Dhabi Global Market"

export default [aprovedCountry, aprovedJurisdiction];